import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Check } from "lucide-react";

interface FormFieldProps {
  label: string;
  id: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  value: string | number | undefined;
  validation: { isValid: boolean; error: string; touched: boolean };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  placeholder?: string;
}

export const FormField = ({
  label,
  id,
  type = "text",
  required = true,
  disabled,
  value,
  validation,
  onChange,
  onBlur,
  placeholder,
}: FormFieldProps) => {
  // Ensure value is always a string, even if undefined or null
  const inputValue = value !== undefined && value !== null ? String(value) : "";

  return (
    <div className="space-y-2.5">
      <Label htmlFor={id} className="text-base font-medium text-gray-700">
        {label}
        {required && " *"}
      </Label>
      <div className="relative">
        <Input
          id={id}
          name={id}
          type={type}
          value={inputValue}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          placeholder={placeholder || label}
          className={`h-12 text-base pr-10 transition-all duration-200 focus:ring-2 placeholder:text-gray-300 ${
            validation.touched && validation.error
              ? "border-red-300 focus:ring-red-500/20 hover:border-red-400"
              : validation.touched && validation.isValid
              ? "border-green-300 focus:ring-green-500/20 hover:border-green-400"
              : "border-gray-200 focus:ring-teal-500/20 hover:border-gray-300"
          }`}
        />
        {validation.touched && validation.isValid && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <Check className="h-5 w-5 text-green-500" />
          </div>
        )}
      </div>
      {validation.touched && validation.error && <p className="text-sm text-red-500">{validation.error}</p>}
    </div>
  );
};
